import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

import { SERVICE_CATALOG } from "@/lib/serviceCatalog";

const ServiceCard = ({ svc }) => {
  const [imgError, setImgError] = useState(false);
  const fallbackImage = "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=400&h=300&fit=crop";
  const imgSrc = imgError ? fallbackImage : svc.image;

  return (
    <div className="group relative aspect-[4/3] rounded-2xl overflow-hidden bg-[#18181B]">
      <img
        src={imgSrc}
        alt={svc.title}
        className="absolute top-0 left-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 opacity-60"
        loading="lazy"
        decoding="async"
        crossOrigin="anonymous"
        referrerPolicy="no-referrer"
        onError={() => setImgError(true)}
      />
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-t from-black/90 via-black/50 to-transparent" />
      <div className="absolute top-0 left-0 w-full h-full flex flex-col justify-end p-4">
        <h3 className="text-lg font-medium text-[#EDEDED] mb-1">{svc.title}</h3>
        <p className="text-xs text-[#A1A1AA] mb-3">
          {svc.species.map((s) => s.charAt(0).toUpperCase() + s.slice(1)).join(" • ")}
        </p>
        <div className="flex flex-col gap-2">
          <Link 
            to={`/browse/${svc.species[0] || "canine"}/services/find?type=${svc.type}`}
            className="text-xs text-[#D4AF37] hover:underline flex items-center gap-1"
          >
            Find a {svc.title} <ChevronRight className="w-3 h-3" />
          </Link>
          <Link 
            to={`/browse/${svc.species[0] || "canine"}/services/register?type=${svc.type}`}
            className="text-xs text-[#A1A1AA] hover:text-[#D4AF37] flex items-center gap-1"
          >
            Register as {svc.title} <ChevronRight className="w-3 h-3" />
          </Link>
        </div>
      </div>
    </div>
  );
};

const ServicesCarousel = () => {
  return (
    <div>
      <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-4">Other Services</p>
      <h2 className="text-2xl md:text-3xl tracking-tight text-[#EDEDED] mb-8">Find Service Providers</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {SERVICE_CATALOG.map((svc) => (
          <ServiceCard key={svc.type} svc={svc} />
        ))}
      </div>
    </div>
  );
};

export default ServicesCarousel;
